<section class="container">
  <div class="header-wrapper">
    <p>
      <span class="headerText"> Modules </span>
    </p>
  </div>
  <div class="content-wrapper">
    @if (loading) {
      <div class="loading">
        <aw-spinner></aw-spinner>
      </div>
    }
    @if (!loading) {
      <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px;">
        @for (module of moduleCards; track module) {
          <aw-module-card [module]="module"
            [syncEnabled]="module.IsEnabled"
            [disabled]="!module.IsEnabled"
            (reset)="resetModuleToLatest($event)"
            (package)="createPackage($event)"
            >
            <div class="card-component-data">
              @if (module.IsEnabled && !module.IsEditable) {
                <div class="card-info" style="margin-bottom: 5px;">
                  <span title="Last Updated">Reset Required</span>
                </div>
              }
              @if (module.IsEnabled && module.IsEditable) {
                <div class="card-info">
                  <span>Live Version:</span>
                  <span>v{{module.LatestServerVersion}}</span>
                </div>
              }
              @if (module.IsEnabled && module.IsEditable) {
                <div class="card-info">
                  <span>Editor Version:</span>
                  <span>{{module.BaseVersionText}}</span>
                </div>
              }
              @if (module.IsEnabled && module.IsEditable) {
                <div class="card-info">
                  <span>Has Changes:</span>
                  @if (module.HasChanges !== 'N/A') {
                    <span class="clickable" [routerLink]="[module.ModuleId, module.MajorBaseVersion, 'diff']" title="View changes">{{module.HasChanges}}</span>
                  }
                  @if (module.HasChanges === 'N/A') {
                    <span>N/A</span>
                  }
                </div>
              }
            </div>
            <div class="card-component-actions">
              @if (module.IsEnabled && module.IsEditable && module.HasChanges === 'Yes') {
                <button mat-menu-item [routerLink]="[module.ModuleId, module.MajorBaseVersion, 'diff']" id="module-card-diff-{{module.ModuleId}}">
                  <mat-icon color="primary">compare_arrows</mat-icon>
                  <span>View Changes</span>
                </button>
              }
              @if (!module.IsEnabled) {
                <button mat-menu-item (click)="enableModuleForTenant(module)">
                  <mat-icon color="primary">add_circle</mat-icon>
                  <span>Enable Module</span>
                </button>
              }
              @if (module.IsEnabled) {
                <button mat-menu-item (click)="disableModuleForTenant(module)">
                  <mat-icon color="warn">remove_circle</mat-icon>
                  <span>Disable Module</span>
                </button>
              }
              @if (module.IsEnabled && module.IsEditable && this.permissionService.hasPermission(permissions.formFlowPatchMigration)) {
                <button mat-menu-item (click)="goToFormFlowPatchMigration(module)">
                  <mat-icon color="primary">launch</mat-icon>
                  <span>Migrate Form Flow</span>
                </button>
              }
            </div>
          </aw-module-card>
        }
      </div>
    }
    <div class="nav-buttons">
      <a mat-raised-button class="mat-accent" data-qa-id="modules-btn-rebuild-translations" (click)="rebuildTranslations()">Rebuild Translations</a>
    </div>
  </div>
</section>